import gql from 'graphql-tag'
export default gql`query chlorideClassQuery($id: Int!) {
  chlorideClass(id: $id) {
    code
    description
    maxChloride
    id
  }
}`